import axios from "axios"

export default {
    namespaced: true,
    state() {
        return {
            marquee: {
                isOn: true,
                html: '<span class="orange--text font-weight-bold">Important:</span> From API, A scheduled maintenance will occur on 18 May between 12:00 to 14:30 (GMT). We apologize for any incovenience caused.',
            },
            user: {
                preferredLanguage: 'en'
            },
            product: [
                { name: 'Sportsbook', navLabel_en: 'Sports', navLabel_cn: '体育', icon: 'soccer' },
                { name: 'Casino', navLabel_en: 'Casino', navLabel_cn: '娱乐场', icon: 'casino' },
                { name: 'Live Casino', navLabel_en: 'Live Casino', navLabel_cn: '真人荷官', icon: 'liveCasino' },
                { name: 'Action Games', navLabel_en: 'Action Games', navLabel_cn: '动作游戏', icon: 'actionGames' },
                { name: 'Chess Game', navLabel_en: 'Chess Game', navLabel_cn: '棋牌', icon: 'chessGame' },
                { name: 'Virtual', navLabel_en: 'Virtual', navLabel_cn: '虚拟体育', icon: 'virtual' },
                { name: 'Lotto', navLabel_en: 'Lotto', navLabel_cn: '彩票', icon: 'lotto' },
            ],
        }
    },
    actions: {
        async refreshAPI(context) {
            await axios.put('https://qol-myaccount-default-rtdb.firebaseio.com/marquee.json', context.state.marquee)
                .then(res => {
                    console.log(res)
                })
                .catch(error => alert(error.message))
            await axios.put('https://qol-myaccount-default-rtdb.firebaseio.com/user.json', context.state.user)
                .then(res => {
                    console.log(res)
                })
                .catch(error => alert(error.message))
            await axios.put('https://qol-myaccount-default-rtdb.firebaseio.com/product.json', context.state.product)
                .then(res => {
                    console.log(res)
                })
                .catch(error => alert(error.message))
        }
    }
}